// 원시 URL 을 경로 템플릿(/students/{id})로 바꾼다. 같은 API 의 에러가 id 마다 다른 이슈로 쪼개지지
// 않게 하는 그룹핑 키이며, API 함수마다 route 를 적지 않아도 되도록 URL 에서 자동 유도한다.

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const NUMERIC = /^\d+$/
// base64 는 camelCase 단어(learningStatisticsSortedType)와 구분이 안 돼 16진수만 해시로 본다.
const HEX_HASH = /^[0-9a-f]{16,}$/i
// POD 주문번호(2610227929e32)처럼 16자보다 짧은 16진수 id. 숫자가 섞인 것만 봐서 영단어와 구분한다.
const SHORT_HEX_ID = /^(?=.*\d)[0-9a-f]{12,}$/i
// 매쓰플랫 사용자·학원 id 는 대문자 한 글자 접두어 + 숫자(학생 I1209566, 학원 D34345)다. 숫자 4자리 이상으로
// 제한해 V2 같은 버전 세그먼트와 구분한다.
const PREFIXED_ID = /^[A-Z]\d{4,}$/

const isSingleId = (segment: string) =>
  NUMERIC.test(segment) ||
  UUID.test(segment) ||
  HEX_HASH.test(segment) ||
  SHORT_HEX_ID.test(segment) ||
  PREFIXED_ID.test(segment)

// 알림 파티션 키처럼 id 를 점으로 이은 세그먼트(D52444.T111525)도 하나의 id 로 본다. id 가 비어 생긴
// null.null 은 조각이 id 가 아니라 그대로 남아, 버그 신호로 따로 묶인다.
const isIdSegment = (segment: string) =>
  isSingleId(segment) || (segment.includes('.') && segment.split('.').every(isSingleId))

const stripOriginAndQuery = (urlPath: string) => {
  const withoutQuery = urlPath.split(/[?#]/)[0] ?? ''
  return withoutQuery.replace(/^https?:\/\/[^/]+/, '')
}

export const toRoute = (urlPath: string, overrides: Record<string, string> = {}): string => {
  const path = stripOriginAndQuery(urlPath)
  const byRaw = overrides[path]
  if (byRaw) return byRaw

  const templated = path
    .split('/')
    .map((segment) => (isIdSegment(segment) ? '{id}' : segment))
    .join('/')

  return overrides[templated] ?? templated
}
